define('v3/Common/Services/Frontend/Popover.Service',[
	'knockout',
	'jquery',
	'lodash',
	'module',
	'v3/Common/Services/Frontend/Mask.Service',
	'require',
	'jquery.popover'
], function (ko, $, _, module, mask, require) {
	function PopoverHelper (event, options) {
		var element = event.delegateTarget || event.currentTarget || event.target || event;

		options.viewModel = options.viewModel || {};

		if (typeof options !== 'object' || !options) {
			throw new Error('Please provide an \'options\' parameter.');
		}

		var defaults = {
			element: options.element || element,
			trigger: (event.type.indexOf('mouse') !== -1) ? 'hover' : 'click',

			viewModel: options.viewModel,
			dom_template: options.template || options.viewModel.template || false,
			context: options.context,
			menu: false,
			promise: $.Deferred(),

			require: null,
			params: null,

			content: false
		};

		delete options.template; // Template is a preserved variable

		this.options = $.extend({}, defaults, options);
		return this.bootstrap();
	}

	PopoverHelper.prototype.bootstrap = function () {
		if (this.options.dom_template && !this.options.menu) {
			if (typeof this.options.viewModel === 'undefined') {
				throw new Error('viewModel is required.');
			}
			if (!_.isObjectLike(this.options.viewModel) || _.isArray(this.options.viewModel)) {
				throw new Error('viewModel requires either a object or a constructor.');
			}
		} else if (this.options.menu) {
			if (!_.isArray(this.options.menu)) {
				throw new Error('Popover menu requires an array.');
			}
		} else if (!this.options.dom_template && !this.options.content && !this.options.require) {
			throw new Error('options.template, viewModel.template, options.content or options.require is required.');
		}

		this.show();
		return this.options.promise;
	};

	PopoverHelper.prototype.show = function () {
		var $elm = $(this.options.element);
		var instance = $elm.popover(this.options);

		instance.options.content = this.create.bind(this, instance.popoverContent);
		instance.show();

		this.options.viewModel.popover = this.options.viewModel.popover || {};
		this.options.viewModel.popover.$ui = instance.popover;

		if (this.options.require) {
			var self = this;
			require([this.options.require], function (viewModel) {
				self.options.requireViewModel = viewModel;
			});
		}

		this.events.onOpen.call(this);
		this.events.onPromiseComplete.call(this);
		this.events.onClose.call(this);
		this.events.onLoading.call(this);

		return $elm;
	};

	PopoverHelper.prototype.create = function (appendTo) {
		var self = this;
		var defferedElement = $.Deferred();

		if (this.options.content) {
			appendTo.html(this.options.content);
		} else if (this.options.dom_template instanceof $) {
			this.options.dom_template.clone().appendTo(appendTo);
			setTimeout(function () {
				defferedElement.resolve(this.options.dom_template);
			}, 0);
		} else if (this.options.menu) {
			var temporaryDiv = $('<ul class="btn-more-content" />').appendTo(appendTo);

			_.each(this.options.menu, function (elm) {
				var db = [];
				var data = $.extend({}, ko.dataFor(self.options.element) || {});
				var vm = (_.isObjectLike(data)) ? data : {};

				var li = $('<li></li>');

				var a = $('<a href="javascript: void(0);"></a>')
					.addClass('btn btn-txt btn-block').appendTo(li);

				var span = $('<span>' + (_.escape(elm.text) || '') + '</span>').appendTo(a);

				if (elm.click) {
					db.push('click: popOverClick');
					vm.popOverClick = elm.click;
				}

				if (elm.disable !== null && elm.disable !== undefined) {
					db.push('css: { "disabled": ' + elm.disable + ' }');
				}

				if (elm.visible !== null && elm.visible !== undefined) {
					li.attr('data-bind', 'visible: ' + elm.visible);
				}

				if (elm.className !== null && elm.className !== undefined) {
					a.addClass(elm.className);
				}

				if (elm.arrow) {
					$('<svg class="btn-icon" data-bind="svgIcon: \'Right\'" />').appendTo(a);
				}

				if (elm.icon) {
					var main = $('<span class="label-icon"/>').insertBefore(span);
					$('<svg class="btn-icon" data-bind="svgIcon: \'' + elm.icon + '\'" />').appendTo(main);
					span.appendTo(main);
				}

				a.attr('data-bind', db.join(', '));
				li.appendTo(temporaryDiv);

				vm.popover = {
					close: function () {
						if (arguments.length === 0) {
							self.options.promise.rejectWith(self.options.context, []);
						} else {
							self.options.promise.resolveWith(self.options.context, arguments);
						}
					}
				};

				ko.applyBindings(vm, li[0]);
			});

			setTimeout(function () {
				defferedElement.resolve(temporaryDiv);
			}, 0);
		} else if (typeof this.options.dom_template === 'string' || this.options.dom_template instanceof String) {
			temporaryDiv = $('<div/>').hide().appendTo(appendTo);
			ko.renderTemplate(
				this.options.dom_template,
				this.options.viewModel,
				{
					afterRender: function (nodes) {
						var $elements = $(nodes).filter(function (i, node) {
							return node.nodeType === 1;
						});

						defferedElement.resolve($elements);
					}
				},
				temporaryDiv,
				'replaceNode'
			);
		} else if (this.options.requireViewModel) {
			temporaryDiv = $('<div>' + this.options.requireViewModel.template + '</div>').hide().appendTo(appendTo);
			delete this.options.require;
			ko.applyBindings(new this.options.requireViewModel.viewModel(this.options.params), temporaryDiv.get(0)); // eslint-disable-line new-cap
			temporaryDiv.show();
			defferedElement.resolve(temporaryDiv);
		} else {
			throw new Error('any template required.');
		}

		return defferedElement;
	};

	PopoverHelper.prototype.events = {

		onLoading: function () {
			if (this.options.viewModel.loader && this.options.viewModel.loader.state) {
				if (this.options.viewModel.loader.state() === 'pending') {
					var instance = $(this.options.element).data('popover');
					instance.popoverLoader.html(null);
					mask.showLoader(instance.popoverLoader);
					instance.popoverContent.hide();

					this.options.viewModel.loader.always(function () {
						if ($(this.options.element).hasClass('openPopover')) {
							mask.hideLoader(instance.popoverLoader);
							instance.popoverContent.show();
							instance.reposition();
						}
					}.bind(this));
				}
			}
		},

		onPromiseComplete: function () {
			this.options.promise.always(function () {
				$(this.options.element).trigger('hide.popover');
				$('.openPopover:not(.alwaysVisible)').trigger('hide.popover');

				if (this.options && this.options.viewModel && _.isFunction(this.options.viewModel.dispose)) {
					this.options.viewModel.dispose();
				}
			}.bind(this));
		},

		onOpen: function () {
			$(document).off('.check.popover').on('mousedown.check.popover touchstart.check.popover', function (e) {
				if (
					!$(e.target).is('html') &&
					!$(e.target).is('.isPopover') &&
					$(e.target).parents('.popover').length === 0 &&
					$(e.target).parents('.isPopover').length === 0
				) {
					$('.openPopover:not(.alwaysVisible)').not(e.target).trigger('hide.popover');
				}
			});
		},

		onClose: function () {
			var self = this;
			$(self.options.element).off('hidden.popover').on('hidden.popover', function () {
				self.options.promise.rejectWith(self.options.context, []);

				// forces WebKIT re-render
				var style = self.options.element.style;
				var initialScale = style.webkitTransform;
				style.webkitTransform = 'scale(1)';
				style.webkitTransform = initialScale;
			});

			self.options.viewModel.popover.close = function () {
				if (arguments.length === 0) {
					self.options.promise.rejectWith(self.options.context, []);
				} else {
					self.options.promise.resolveWith(self.options.context, arguments);
				}
			};
		}

	};

	return function (event, options) {
		return new PopoverHelper(event, options);
	};
});

